import { axios } from '@/axios.config';
export const state = {
  loading: {
    patch: false,
  },
};

export const actions = {
  /**
   * POST New password
   * @return AxiosPromise<any>
   */
  patchPassword({ commit }, arg) {
    const url = '/user/password';
    let params = { pw_old: arg.currentPassword, pw_new: arg.newPassword };

    commit('requestStart', 'patch');

    return axios
      .patch(url, params)
      .then(res => {
        commit('requestSucceed', 'patch');

        if (res.data.status === 'error') {
          return Promise.reject('Wrong password');
        }

        return Promise.resolve();
      })
      .catch(res => {
        commit('requestFailed', 'patch');

        if (res.response.data.message === 'pw_old not specified') {
          return Promise.reject('Wrong password');
        }

        if (res.response.data.message === 'User function is failed.') {
          return Promise.reject('Wrong password');
        }

        return Promise.reject('Change password failed');
      });
  },
};

export const mutations = {
  requestStart(state, { method }) {
    state.loading[method] = true;
  },

  requestSucceed(state, { method }) {
    state.loading[method] = false;
  },

  requestFailed(state, { method }) {
    state.loading[method] = false;
  },
};
export const getters = {};
